const UNLAUNCHED_PAYMENT_STATUSES = ['none', 'pending', 'pre_approved', 'cancelled'];

export const PATCH_MAX_CONTENTS_DISPLAYS = 400;

const groupRowsByDisplay = rows =>
  rows.reduce((groups, row) => {
    const displayId = Number(row.display_id);
    groups[displayId] = [...(groups[displayId] || []), row];
    return groups;
  }, {});

export const buildContentsDisplaysPatch = (originalRows, currentRows) => {
  const originalByDisplay = groupRowsByDisplay(originalRows);
  const currentByDisplay = groupRowsByDisplay(currentRows);

  const changedDisplayIds = Object.keys(currentByDisplay).filter(
    displayId =>
      JSON.stringify(currentByDisplay[displayId]) !== JSON.stringify(originalByDisplay[displayId])
  );
  const removedDisplayIds = Object.keys(originalByDisplay).filter(
    displayId => !currentByDisplay[displayId]
  );

  return {
    contents_displays: currentRows.filter(row =>
      changedDisplayIds.includes(String(Number(row.display_id)))
    ),
    removed_display_ids: removedDisplayIds.map(Number),
  };
};

export const isLaunchedPaymentStatus = paymentStatus =>
  !UNLAUNCHED_PAYMENT_STATUSES.includes(paymentStatus);
